const uriApi = 'https://api.buildsolutions.com.br';

export default uriApi;
